export default __webpack_public_path__ + "4a2bf75c901f37bef45d655e1fb5efe0f8352e5a59288816fe372e130976ccd3.svg";